
import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from '@/components/ui/dialog';
import { MapPin, Plus } from 'lucide-react';
import { LocationInput } from '@/components/LocationInput';

interface NoLocationSelectedProps {
  isNewLocationDialogOpen: boolean;
  setIsNewLocationDialogOpen: (open: boolean) => void;
  onNewLocationSelect: (location: { name: string; latitude: number; longitude: number } | null) => void;
}

export const NoLocationSelected: React.FC<NoLocationSelectedProps> = ({
  isNewLocationDialogOpen,
  setIsNewLocationDialogOpen,
  onNewLocationSelect
}) => {
  return (
    <Card>
      <CardContent className="flex flex-col items-center justify-center py-12">
        <MapPin className="w-16 h-16 text-muted-foreground mb-4" />
        <h3 className="text-lg font-semibold mb-2">No Location Selected</h3>
        <p className="text-muted-foreground text-center mb-6">
          Select a favorite location from the Locations tab or start a new calendar by entering location information
        </p>
        
        <Dialog open={isNewLocationDialogOpen} onOpenChange={setIsNewLocationDialogOpen}>
          <DialogTrigger asChild>
            <Button>
              <Plus className="w-4 h-4 mr-2" />
              Start New Calendar
            </Button>
          </DialogTrigger>
          <DialogContent className="max-w-lg max-h-[90vh] overflow-y-auto">
            <DialogHeader>
              <DialogTitle>Start New Calendar</DialogTitle>
            </DialogHeader>
            <div className="space-y-4">
              <p className="text-sm text-muted-foreground">
                Enter a location to view the Milky Way calendar for that area
              </p>
              <LocationInput onLocationChange={onNewLocationSelect} />
            </div>
          </DialogContent>
        </Dialog>
      </CardContent>
    </Card>
  );
};
